/**
 * List of all Ethereum asset type IDs across all networks
 * Used to identify ETH assets for staking, special handling, etc.
 */
export const ETH_ASSETS = [
  'ETHTEST',
  'ETH',
  'ETH_R',
  'ETHHOODI',
  'ETHHOL',
  'ETHSEP',
  'ETHDEV',
  'ETH_TG',
  'ETH_TR',
] as const;

/**
 * Type-safe ETH asset type ID
 */
export type ETHAssetTypeID = (typeof ETH_ASSETS)[number];

/**
 * Checks if a given asset type ID is an Ethereum asset
 *
 * @param assetTypeID - The asset type ID to check (e.g., 'ETH', 'BTC_R', etc.)
 * @returns true if the asset is an Ethereum asset, false otherwise
 *
 * @example
 * ```typescript
 * assetIsETH('ETH')      // true
 * assetIsETH('ETH_R')    // true
 * assetIsETH('BTC')      // false
 * assetIsETH(null)       // false
 * assetIsETH(undefined)  // false
 * ```
 */
export const assetIsETH = (
  assetTypeID?: string | null,
): assetTypeID is ETHAssetTypeID => {
  if (!assetTypeID) {
    return false;
  }
  return (ETH_ASSETS as readonly string[]).includes(assetTypeID);
};
